export default __webpack_public_path__ + "static/ai_diagram-6ea0a7aec6713bd1271eaf3ab7935f2d.svg";